export function loader(toggle) {
    if (typeof toggle === 'undefined') {
        $('body').toggleClass('state-loading');
    } else {
        $('body').toggleClass('state-loading', toggle);
    }
}

export function isLoading() {
    $('body').hasClass('state-loading');
}
